module.exports = __webpack_public_path__ + "static/media/adjust.5a258a69.svg";